var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThanhtongny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#F04438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.8C8.75 12.441 9.0578 12.15 9.4375 12.15H13.5625C13.9422 12.15 14.25 12.441 14.25 12.8C14.25 13.159 13.9422 13.45 13.5625 13.45H9.4375C9.0578 13.45 8.75 13.159 8.75 12.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 9.875C9.0578 9.875 8.75 10.166 8.75 10.525C8.75 10.884 9.0578 11.175 9.4375 11.175H13.5625C13.9422 11.175 14.25 10.884 14.25 10.525C14.25 10.166 13.9422 9.875 13.5625 9.875H9.4375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15.075C8.75 14.716 9.0578 14.425 9.4375 14.425H13.5625C13.9422 14.425 14.25 14.716 14.25 15.075C14.25 15.434 13.9422 15.725 13.5625 15.725H9.4375C9.0578 15.725 8.75 15.434 8.75 15.075Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.125 5C9.36561 5 8.75 5.58203 8.75 6.3L8.0625 6.3C6.92341 6.3 6 7.17305 6 8.25V16.05C6 17.127 6.92341 18 8.0625 18H14.9375C16.0766 18 17 17.127 17 16.05V8.25C17 7.17304 16.0766 6.3 14.9375 6.3H14.25C14.25 5.58203 13.6344 5 12.875 5H10.125ZM12.875 6.3H10.125V7.6H12.875V6.3ZM8.75 7.6H8.0625C7.6828 7.6 7.375 7.89102 7.375 8.25V16.05C7.375 16.409 7.6828 16.7 8.0625 16.7H14.9375C15.3172 16.7 15.625 16.409 15.625 16.05V8.25C15.625 7.89102 15.3172 7.6 14.9375 7.6H14.25C14.25 8.31797 13.6344 8.9 12.875 8.9H10.125C9.36561 8.9 8.75 8.31797 8.75 7.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanhtongny);
export default __webpack_public_path__ + "static/media/thanh toán gần đây.1810e69810b067c013dd4683a193a434.svg";
export { ForwardRef as ReactComponent };